import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const augustaOptions: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const augustaEmergencyDescription =
  "Atlanta ~145 mi via I-20 — do not be fooled by what looks like a simple 2.5-hour drive. Georgia has only ONE passport agency serving 11M+ residents statewide. During Masters Week (early April), Augusta's population triples overnight — 250,000+ visitors from 90+ countries descend on the city simultaneously. International patrons discovering passport issues days before their flight to Augusta face a single Atlanta agency already overwhelmed by Georgia's 11M. Fort Eisenhower deploys thousands of soldiers and contractors worldwide — a service member with orders to Germany or Korea cannot wait on I-20 traffic through the Georgia Piedmont. When severe thunderstorms or the occasional ice storm close I-20 east of Atlanta, Augusta is severed from the state's only passport agency with no viable alternate route through the Sumter National Forest. One agency. 11 million Georgians. And during Masters Week, your competition for that appointment includes golf fans from six continents.";

const augustaDisclaimer =
  "Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Fort Eisenhower personnel should consult their unit's administrative office for deployment-specific passport guidance.";

export default function AugustaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Augusta"
      headingExtra="GA"
      introText="Augusta and CSRA travelers — Masters patrons, Fort Eisenhower personnel, Augusta University medical faculty, and Garden City families — have several options for getting a passport fast. Here is how they compare, and why most Augusta-area residents choose a U.S. Department of State registered passport courier for predictable, professional processing."
      options={augustaOptions}
      emergencyDescription={augustaEmergencyDescription}
      disclaimerText={augustaDisclaimer}
    />
  );
}